import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Card,
  CardBody,
  CardHeader,
  HStack,
  Heading,
} from "@chakra-ui/react";
import React from "react";

/**
 * Renders a primary card component
 * 
 * @param {Object} props - The props of the component
 * @returns A primary card component
 */
const PrimaryCard = ({
  title,
  ActionButton = null,
  accordion = false,
  children,
  ...props
}) => (
  <Card variant={"primary"} {...props}>
    {accordion ? (
      <Accordion allowMultiple>
        <AccordionItem>
          <CardHeader padding={"8px"}>
            <AccordionButton width={"full"}>
              <HStack justifyContent={"space-between"} width={"full"}>
                <Heading fontSize={"16px"} fontWeight={400}>{title}</Heading>
                <AccordionIcon />
              </HStack>
            </AccordionButton>
          </CardHeader>
          <CardBody padding={"8px"}>
            <AccordionPanel>
              {ActionButton}
              {children}
            </AccordionPanel>
          </CardBody>
        </AccordionItem>
      </Accordion>
    ) : (
      <React.Fragment>
        <CardHeader padding={"8px"}>
          <HStack justifyContent={"space-between"}>
            <Heading fontSize={"16px"} fontWeight={"bold"}>{title}</Heading>
            {ActionButton}
          </HStack>
        </CardHeader>
        <CardBody padding={"8px"}>{children}</CardBody>
      </React.Fragment>
    )}
  </Card>
);

export default React.memo(PrimaryCard);
